module.exports = __webpack_public_path__ + "img/a3370a2.png";